module.exports = __webpack_public_path__ + "img/Vimkey-macOS-store-search&open.3f774c6f.png";